import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import CheckIcon from "@mui/icons-material/Check";
import IconButton from "@mui/material/IconButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { useContext ,useState} from "react";
import { TodosContext } from "../contexts/myContext";
import TextField from "@mui/material/TextField";

// package Delete modal 
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


export default function Todo({ todo }) {
  const {todos,SetTodos} =useContext(TodosContext);
  const [showModalDelete,setShowModalDelete]=useState(false);
  const [showModalUpdate,setShowModalUpdate]=useState(false);
  const [editTodo,setEditTodo]=useState({title:todo.title,details:todo.details});

  // handlClick Function
  function handDeleteClick(){
    setShowModalDelete(true)
  }
  function hiddenModalDelete(){
    setShowModalDelete(false)
  }
  
  function handClickCheck() {
    const updateTodo = todos.map((t) => {
      if (t.id === todo.id) {
        if (t.isCompleted === false) {
          t.isCompleted = true;
        } else {
          t.isCompleted = false;
        }
      }
      return t;
    });
    SetTodos(updateTodo);
    localStorage.setItem("todos",JSON.stringify(updateTodo))
  }
  function handDeleteConfirm(){
    const updateTodo=todos.filter((t)=>{
      return t.id!==todo.id;
    })
    SetTodos(updateTodo);
    localStorage.setItem("todos",JSON.stringify(updateTodo))
  }
  function handlUpdateClick(){
    setShowModalUpdate(true)
  }
  function handlCloseUpdate(){
    setShowModalUpdate(false)
  }
  function handlUpdateConfirm(){  
    const updateEditBtn=todos.map((e)=>{
      if(e.id===todo.id){
        return ({...e,title:editTodo.title,details:editTodo.details})
      }else{
        return e;
      }
    })
    SetTodos(updateEditBtn)
    setShowModalUpdate(false)
    localStorage.setItem("todos",JSON.stringify(updateEditBtn))
  }
  //========== handlClick Function =============
  return (
    <>
    {/* Delete Modal  */}
    <Dialog
        open={showModalDelete}
        onClose={hiddenModalDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{direction:"rtl"}}
      >
        <DialogTitle id="alert-dialog-title" style={{fontWeight:"bold"}}>
          {"هل أنت متأكد من رغبتك في حذف المهمة ؟"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" style={{fontWeight:"bold"}}>
            لا يمكنك التراجع عن الحذف بعد أتمامه .
          </DialogContentText>
        </DialogContent>
        <DialogActions >
          <Button onClick={hiddenModalDelete}  style={{fontWeight:"bold"}}>إغلاق</Button>
          <Button style={{color:"red",fontWeight:"bold"}} onClick={handDeleteConfirm} autoFocus>
            نعم قم بالحذف
          </Button>
        </DialogActions>
      </Dialog>
    {/*========== Delete Modal ======== */}

    {/* update  Modal  */}
    <Dialog
        open={showModalUpdate}
        onClose={handlCloseUpdate}
        style={{direction:"rtl"}}
      >
        <DialogTitle style={{fontWeight:"bold"}}>تعديل المهمة</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            required
            margin="dense"
            id="name"
            name="email"
            label="عنوان المهمة"
            fullWidth
            variant="standard"
            value={editTodo.title}
            onChange={(e)=>{
              setEditTodo({...editTodo,title:e.target.value})
            }}
          />
          <TextField
            autoFocus
            required
            margin="dense"
            id="name"
            name="email"
            label="التفصيل"
            fullWidth
            variant="standard"
            value={editTodo.details}
            onChange={(e)=>{
              setEditTodo({...editTodo,details:e.target.value})
            }}
            
          />
        </DialogContent>
        <DialogActions>
          <Button  onClick={handlCloseUpdate} style={{fontWeight:"bold"}}>إغلاق</Button>
          <Button type="submit" style={{fontWeight:"bold"}} onClick={handlUpdateConfirm}>تأكيد</Button>
        </DialogActions>
      </Dialog>
    {/*========= update  Modal ========== */}
    <Card
      className="TodoCard"
      sx={{
        minWidth: 275,
        background: "#283593",
        color: "white",
        marginTop: 5,
      }}
    >
      <CardContent>
        <Grid container spacing={2}>
          <Grid
            size={4}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-around"}
          >
            <IconButton
              className="iconBottom"
              sx={{
                color: "red",
                background: "white",
                border: "solid red   3px",
              }}
              onClick={handDeleteClick}
            >
              <DeleteOutlinedIcon />
            </IconButton>

            <IconButton
              className="iconBottom"
              sx={{
                color: "#1769aa",
                background: "white",
                border: "solid #1769aa 3px",
              }}
              onClick={handlUpdateClick}
            >
              <EditOutlinedIcon />
            </IconButton>

            <IconButton
              className="iconBottom"
              sx={{
                color: todo.isCompleted ? "white" : "#8bc34a",
                background: todo.isCompleted ? "#8bc34a" : "white",
                border: "solid #8bc34a 3px",
              }}
              onClick={() => {
                handClickCheck();
              }}
            >
              <CheckIcon />
            </IconButton>
          </Grid>
          <Grid size={8}>
            <Typography variant="h5" sx={{ textAlign: "right"   ,textDecoration:todo.isCompleted ? "line-through" :"none" }}>
              {todo.title}
            </Typography>
            <Typography variant="h6" sx={{ textAlign: "right" ,textDecoration:todo.isCompleted ? "line-through" :"none" }}>
              {todo.details}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
    </>
    
  );
}
